
import store from '@/store'
import { getToken } from './auth'
if (getToken())
store.dispatch('app/getCommonData')